import React from "react";

/** Two-column label + content grid row used in all forms. */
export function FormField({
  label,
  labelWidth = 220,
  description,
  children,
}: {
  label: string;
  /** Label column width in px. Defaults to 220. */
  labelWidth?: number;
  /** Optional subtitle shown below the label in smaller muted text. */
  description?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className="grid items-start gap-3"
      style={{ gridTemplateColumns: `${labelWidth}px 1fr` }}
    >
      <label className="text-sm font-medium text-right text-gray-600 dark:text-gray-400 pt-1.5">
        {label}
        {description && (
          <span className="block text-xs text-gray-400 dark:text-gray-500 font-normal mt-0.5">
            {description}
          </span>
        )}
      </label>
      <div>{children}</div>
    </div>
  );
}
